import {useErrors} from "base/error/provider";
import {useNavigateWithReload} from "base/navigation/hooks";
import {PermitService} from "permit/service";
import {Spinner} from "base/shared/components";
import {ViewPermitExtensionMaterialsTable} from ".";

const PermitExtensionMaterialsContent = ({
    extension,
    displayFees = true,
    disabled = false,
}) => {
    const {handleErrors} = useErrors();
    const navigate = useNavigateWithReload();

    const handleFormSubmit = materials => {
        PermitService.extendMaterials(extension?.permit?.id, materials)
            .then(response => {
                navigate("", true);
            })
            .catch(error => handleErrors(error));
    };

    return !extension ? (
        <Spinner key="spinner" />
    ) : (
        <ViewPermitExtensionMaterialsTable
            extension={extension}
            onSubmit={handleFormSubmit}
            displayFees={displayFees}
            disabled={disabled}
        />
    );
};

export default PermitExtensionMaterialsContent;
